const PT = require("prop-types");
const React = require("react");

const createReactClass = require("create-react-class");

const styles = require("./styles/ImageLoadSwitch.css");

module.exports = createReactClass({
	displayName: "ImageLoadSwitch",

	propTypes: {
		className: PT.string.isRequired,
		imageSrc: PT.string.isRequired,
		fallbackImageSrc: PT.string.isRequired,
		alt: PT.string,
	},

	getInitialState: function() {
		return {
			loaded: false,
		};
	},

	handleLoad: function() {
		this.setState({
			loaded: true,
		});
	},

	render: function() {
		const fallbackStyle = {};
		if (this.state.loaded) fallbackStyle.display = "none";

		const imgA = (
			<img
				className={styles.fallbackImage}
				style={fallbackStyle}
				alt={this.props.alt}
				src={this.props.fallbackImageSrc}
			/>
		);
		const imgB = (
			<img
				className={styles.mainImage}
				onLoad={this.handleLoad}
				alt={this.props.alt}
				src={this.props.imageSrc}
			/>
		);

		return (
			<div className={this.props.className}>
				{imgB}
				{imgA}
			</div>
		);
	},
});
